/**
 * Router Configuration
 *
 * Creates and exports the application router.
 */

import { createBrowserRouter } from 'react-router-dom';
import { routes } from './routes';

export const router = createBrowserRouter(routes);

export { routes } from './routes';
export { AuthGuard, GuestGuard } from './guards';

export default router;
